import { render, staticRenderFns } from "./CanGetExtraFreeTooltip.vue?vue&type=template&id=06682eaf&"
import script from "./CanGetExtraFreeTooltip.vue?vue&type=script&lang=js&"
export * from "./CanGetExtraFreeTooltip.vue?vue&type=script&lang=js&"
import style0 from "./CanGetExtraFreeTooltip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports